<template lang="pug">
.ui.form-customers(:class='{segments}')
  form-new-customer.ui(v-for='(customer, index) of customers',
    :class='{segment:segments}', :cancelable='cancelable'
    :key='index', :form='customer', :removable='removable && customers.length > 1',
    @remove='customer_remove', ref='customers')

  .ui.right.aligned(:class='{segment:segments}')
    .ui.button.tiny.themed.icon.labeled(@click='customer_add')
      i.add.icon
      | 添加住户
</template>

<script>
import FormNewCustomer from './FormNewCustomer.vue'

export default {
  name: 'form-customers',
  components: { FormNewCustomer },
  props: {
    customers: Array,
    segments: { type: Boolean, default: true },
    removable: { type: Boolean, default: true },
    cancelable: { type: Boolean, default: true },
  },
  methods: {
    customer_remove(customer) {
      const i = this.customers.indexOf(customer)
      if (i >= 0)
        this.customers.splice(i, 1)
    },
    customer_add() {
      this.customers.push({})
    },
    form_validate() {
      const promises = []
      for (const $customerForm of this.$refs.customers)
        promises.push($customerForm.form_validate())
      return Promise.all(promises)
    },
  },
}
</script>



// WEBPACK FOOTER //
// FormCustomers.vue?a9d74cd2